import BCMSRecord from "../BCMSRecord";
import BCMSCurrency from "../BCMSCurrency";

export default class BCMSDefaultModel {
    static _GlobalController; // Used for accessing global state

    // :: OBJECT -> VOID
    // Sets the global controller for the class
    static globalController(globalController) {
        this._GlobalController = globalController;
        return this;
    }

    // :: OBJECT -> VOID
    // Sets static methods for the class to return default model
    static setDefaults(classes) {
        // Loop through each item in the 'defaultModel' array
        if(this._GlobalController.state.defaultModel !== undefined && Array.isArray(this._GlobalController.state.defaultModel)) {
            this._GlobalController.state.defaultModel.forEach(item => {   
                // Use the 'defaultModelName' property as the name of the function         
                this[item.defaultModelName] = () => {
                    const className = item.defaultModelClass;
                    // If the 'defaultModelClass' is defined and not an empty string
                    // Then check if the class exists, if not throw an error otherwise return
                    // an initalized instance
                    if(className !== undefined && className.length > 0) {
                        if(classes[className] === undefined) {
                            throw new Error(`Could not initalize default model with class "${ className }". Verify that the "${ className }" class has been initalized with a global controller.`);
                        }
    
                        return classes[className].init(item);
                    }
                    // Return the object without initalizing an instance of a class
                    return item;
                };
            });
        }
    }

    // :: OBJECT|BCMSRecord, OBJECT|BCMSRecord -> OBJECT
    // Merge in the default values into the passed record
    // Values with be overwritten if an amount is equal to zero and if the length of a string is zero
    // Values can only be overwritten if the same property exists within the default object
    static mergeRecords(record, defaults) {
        // :: OBJECT|BCMSRecord -> OBJECT
        // Returns the record of the passed instance
        const getRecord = value => value instanceof BCMSRecord || value.prototype instanceof BCMSRecord ? value.record : value;
        // Get the properties of the record, filtering out any properties that have an underscore
        Object.getOwnPropertyNames(record)
            .filter(item => item.indexOf("_") === -1, [])
            .forEach((key, index) => {
                // If the property returns an instance of BCMSCurrency
                // Check if the amount is equal to zero, if so overwrite the value with whats set in default
                if(record[key] instanceof BCMSCurrency) {
                    record[key] = record[key] == undefined || parseFloat(record[key].amount) === 0 ? defaults[key] ?? record[key] : record[key];
                }
            });
        // Get the records of the instances
        record = getRecord(record);
        defaults = getRecord(defaults);
        // For each property in the record, check if the value is an empty string or undefined
        // If so overwrite the property with what is set in default
        return Object.keys(record).reduce((result, key) => {
            const value = record[key];
            const defaultValue = defaults[key];

            return { ...result, [key] : value === undefined || value.length === 0 ? defaultValue ?? value : value };
        }, {});
    }
}